<template>
  <main class="md:px-44 px-7 md:overflow-auto h-screen bg-up-down-butterfly bg-up-down-butterfly--login-page bg-greyBackground">
    <!-- nav-bar -->
    <nav class="pt-20 top-0 md:grid hidden grid-cols-2">
      <div
        class="md:flex gap-16"
        :class="{ 'flex-row-reverse ': isOkCredit }"
      >
        <img
          src="../assets/logo-primary.svg"
          alt="ePaylater Logo"
          class="w-28 md:w-44 h-auto"
        />
        <img
          :src="imageUrl"
          alt="Marketplace Logo"
          v-if="imageUrl"
          class="w-28 md:w-44 h-auto"
        />
      </div>
      <div class="justify-self-end">
        <img
          src="../assets/google-play.svg"
          alt="Marketplace Logo"
          class="w-28 md:w-40 h-auto cursor-pointer"
        />
      </div>
    </nav>
    <section class="md:grid md:grid-cols-2">
      <!-- left-section -->
      <div
        class="grid col-span-1 items-start md:mt-24 gap-4"
      >
      <!-- slider-section -->
      <div v-if="this.microAppsUrlParams.m_code !== 'GPAY'" class="slider">
        <!-- mobile-view -->
        <section v-if="isUpdateMobileNoFocusBlur" class="md:hidden block py-8">
          <!-- mobile-view logo -->
          <div
            class="md:flex gap-16 pt-1"
            :class="{ 'flex-row-reverse ': isOkCredit }"
          >
            <img
              src="../assets/logo-primary.svg"
              alt="ePaylater Logo"
              class="w-28 h-auto"
            />
            <img
              :src="imageUrl"
              alt="Marketplace Logo"
              v-if="imageUrl"
              class="w-28 h-auto"
            />
          </div>
        </section>
      <section v-else class="md:hidden block pt-8">
        <div class="slides" :style="{ transform: 'translateX(-' + currentSlide * (100 / slides.length) + '%)' }">
            <div v-for="(slide, index) in slides" :key="index" class="slide">
              <div class="text-left grid gap-2">
                <div class="flex justify-between gap-2">
                  <div>
                    <p class="text-2xl font-blogger font-bold">{{ slide.title }}</p>
                  </div>
                  <!-- mobile-view logo -->
                  <div
                    class="md:flex gap-16 pt-1"
                    :class="{ 'flex-row-reverse ': isOkCredit }"
                  >
                    <img
                      src="../assets/logo-primary.svg"
                      alt="ePaylater Logo"
                      class="w-28 h-auto"
                    />
                    <img
                      :src="imageUrl"
                      alt="Marketplace Logo"
                      v-if="imageUrl"
                      class="w-28 h-auto"
                    />
                  </div>
                </div>
                <div class="pr-32">
                  <p class="text-xs font-myriad text-textSecondary">{{ slide.description }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="slides" :style="{ transform: 'translateX(-' + currentSlide * (100 / slides.length) + '%)' }">
            <div v-for="(slide, index) in slides" :key="index" class="slide">
              <div class="py-16">
                <Vue3Lottie :animationData="slide.url" :speed="1" :loop="true" :height="250" :width="250"/>
              </div>
            </div>
          </div>
          <div class="auto-switch pb-11">
            <span class="h-1 w-4" v-for="(slide, index) in slides" :key="slide.id" :class="{ active: index === currentSlide }" @click="setSlide(index)"></span>
          </div>
        </section>
        <section v-if="$route.name === 'Verify Otp'" class="md:hidden block">
          <div>
            <Vue3Lottie :animationData="Otp" :speed="1" :loop="true" :height="250" :width="250"/>
          </div>
        </section>
        <!-- web-view -->
        <!-- Verify Otp -->
        <section v-if="$route.name === 'Verify Otp'" class="md:block hidden">
          <div class="pb-16">
            <Vue3Lottie :animationData="Otp" :speed="1" :loop="true" :height="550" :width="550"/>
          </div>
          <p class="text-4xl font-blogger font-bold">OTP Verification</p>
        </section>
        <!-- mobile-no -->
        <section v-else class="md:block hidden">
          <div class="slides" :style="{ transform: 'translateX(-' + currentSlide * (100 / slides.length) + '%)' }">
            <div v-for="(slide, index) in slides" :key="index" class="slide">
              <div class="py-0">
                <Vue3Lottie :animationData="slide.url" :speed="1" :loop="true" :height="550" :width="550"/>
              </div>
            </div>
          </div>
          <div class="auto-switch py-11">
            <span class="h-2 w-8" v-for="(slide, index) in slides" :key="slide.id" :class="{ active: index === currentSlide }" @click="setSlide(index)"></span>
          </div>
          <div class="slides" :style="{ transform: 'translateX(-' + currentSlide * (100 / slides.length) + '%)' }">
            <div v-for="(slide, index) in slides" :key="index" class="slide">
              <div class="text-left grid gap-6">
                <p class="text-4xl font-blogger font-bold">{{ slide.title }}</p>
                <p class="text-xl font-myriad text-textSecondary">{{ slide.description }}</p>
              </div>
            </div>
          </div>
        </section>
      </div>
        <!-- <div
          class="md:py-8 md:px-7 text-center gap-3 justify-center justify-items-center"
          :class="$route.name === 'Verify Otp' ? 'hidden md:grid' : 'grid'"
        >
          <h2 class="text-xl font-bold">Instant Business Credit</h2>
          <p class="text-sm">
            Get up to 25 lakhs credit limit
            <template v-if="!isColgate && !isOkCredit">at 0% interest*</template>
          </p>
          <p class="text-sm">Instant approval and quick activation</p>
          <p class="text-sm">Simple & paperless documentation</p>
          <p
            v-if="isWalmart"
            class="text-lg font-bold bg-bannerGreen text-white px-4 py-2 flex gap-2 items-center rounded mt-4"
          >
            <img src="../assets/offer-icon.svg" alt="Offer Icon" width="30" height="30" />
            Upto ₹{{ isWalmart ? 250 : 500 }} cashback on limit activation
          </p>
        </div> -->
      </div>
      <!-- right-section -->
      <div class="col-span-1 md:grid" ref="form">
        <div class="md:shadow-cardShadow card-w justify-self-end opacity-100 rounded-rounded4xl md:mt-20 mb-14 bg-greyBackground md:px-16 md:pt-14 md:pb-12  md:grid items-start md:gap-8 gap-4">
          <router-view :key="$route.fullPath"></router-view>
        </div>
        <footer class="md:grid hidden grid-cols-2 pb-20 card-w justify-self-end">
          <section class="grid gap-3">
            <p class="font-myriad text-xl font-bold">CERTIFICATES</p>
            <div class="flex gap-4">
              <img
                src="../assets/certificate-1.png"
                alt="certificate"
                class="w-16 h-16"
              />
              <img
                src="../assets/certificate-2.png"
                alt="certificate"
                class="w-16 h-16"
              />
              <img
                src="../assets/certificate-3.png"
                alt="certificate"
                class="w-16 h-16"
              />
              <img
                src="../assets/certificate-4.png"
                alt="certificate"
                class="w-16 h-16"
              />
            </div>
          </section>
          <section class="grid gap-3">
            <p class="font-myriad text-xl font-bold">SECURITY</p>
            <div class="flex gap-4">
              <img
                src="../assets/security-1.png"
                alt="certificate"
                class="w-48 h-16"
              />
              <img
                src="../assets/security-2.png"
                alt="certificate"
                class="w-48 h-16"
              />
            </div>
          </section>
        </footer>
      </div>
    </section>
  </main>
  <!-- Spin Loader -->
  <spin-loader :spinLoading="isSpinLoading"/>
</template>
<script>
import { mapGetters } from 'vuex';
import flyingMan from '../assets/animation/flying man.json';
import instantCredit from '../assets/animation/instant Credit.json';
import ZeroCost from '../assets/animation/Zero cost.json';
import SpinLoader from '../components/spinLoader.vue';
import Otp from '../assets/animation/OTP.json';

export default {
  name: 'Login',
  components: {
    SpinLoader
  },
  data() {
    return {
      slides: [
        { id: 1, url: flyingMan, title: 'Fast Credit', description: 'On your marks, Get set, Give your business the wings to fly with quick credit!' },
        { id: 2, url: ZeroCost, title: 'Zero Cost Credit', description: 'The only zero in your business should be 0 cost credit!' },
        { id: 3, url: instantCredit, title: '₹25 lakhs Credit', description: 'Up to 25 lakh interest free credit is waiting for you!' },
      ],
      currentSlide: 0,
      Otp,
      isSpinLoading: undefined,
    };
  },
  computed: {
    ...mapGetters([
      'sessionId',
      'imageUrl',
      'isWalmart',
      'isColgate',
      'isOkCredit',
      'microAppsUrlParams',
      'isUpdateMobileNoFocusBlur'
    ]),
  },
  watch: {
    sessionId() {
      if (this.sessionId) {
        this.$store.dispatch('marketplaceLogoUrl', {
          queryParams: { sessionId: this.sessionId },
        });
      }
    },
    isUpdateMobileNoFocusBlur() {
      this.isSpinLoading = false;
    }
  },
  created() {
    // Delete marketplaceInfo from localStorage
    if (localStorage.getItem('marketplaceInfo')) {
      localStorage.removeItem('marketplaceInfo');
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      setInterval(this.nextSlide, 5000);
      const { supportId } = this.$route.query;
      if (supportId) {
        this.$store.commit('SET_SUPPORT_ID', supportId);
      }
      // Redirect To on-boarding Or Normal
      if (this.microAppsUrlParams) {
        if (this.microAppsUrlParams.redirect === 'on-boarding' ||
          this.microAppsUrlParams.redirect === 'suppliers' ||
          this.microAppsUrlParams.redirect === 'transaction-list' ||
          this.microAppsUrlParams.redirect === 'transaction-details' ||
          this.microAppsUrlParams.redirect === 'on-boarding-testing' ||
          this.microAppsUrlParams.redirect === 'suppliers-testing' ||
          this.microAppsUrlParams.redirect === 'transaction-details-testing' ||
          this.microAppsUrlParams.redirect === 'transaction-list-testing'
        ) {
          this.isSpinLoading = true;
        }
      }
    },
    showForm() {
      this.$refs.form.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      });
    },
    nextSlide() {
      if (this.currentSlide === this.slides.length - 1) {
        this.currentSlide = 0;
      } else {
        this.currentSlide += 1;
      }
    },
    setSlide(index) {
      this.currentSlide = index;
    },
  },
};
</script>
<style scoped>
.slider {
  position: relative;
  overflow: hidden;
}
.slides {
  display: flex;
  width: calc(100% * 3);
  transition: transform 0.5s ease;
}
.slide {
  flex-shrink: 0;
  width: calc(100% / 3);
  box-sizing: border-box;
}
.auto-switch {
  display: flex;
  gap: 0.5rem;
}
  .auto-switch span {
    display: inline-block;
    background-color: #A1B0B7;
    border-radius: 4px;
    cursor: pointer;
  }
  .auto-switch .active {
    background-color: #286091;
    cursor: default;
  }
  @media (min-width: 768px) {
    .lottie-animation-container {
      margin: 0px !important;
    }
  }
</style>
